import React from 'react';

import { ColumnsType } from 'antd/es/table';
import { Dayjs } from 'dayjs';

import { PagintaionParams } from 'shared/CustomPagination/CustomPagination';
import TableSchedules from 'shared/TableComponents/TableSchedules';
import TableTimePicker from 'shared/TableComponents/TableTimePicker';

import { BookingWaitList } from 'features/bookingWait';
import { WorkTime } from 'features/config';
import { CourtsList } from 'features/courts';
import { CourtsBooking, SelectedBookingCourt } from 'features/courtsBooking';

import GraphColumns from './components/GraphColumns';

interface Props {
  onTimeChange: (arg: Dayjs) => void;
  handleBooking: (arg: SelectedBookingCourt) => void;
  handleCheckDetail: (ids: number[]) => void;
  editWaiting: (bookingsWaitId: number[]) => void;
  onTimeClick: (time: string) => void;
  items: CourtsBooking;
  params: PagintaionParams;
  bookingTime: null | Dayjs;
  courts: CourtsList;
  workTime: WorkTime;
  waitingList: BookingWaitList;
  activeTimeList: string[];
}
export interface TableData extends CourtBooking {
  key: number;
}

type CourtBooking = CourtsBooking[number];

function BookingTableColumns({
  onTimeChange,
  handleBooking,
  handleCheckDetail,
  onTimeClick,
  editWaiting,
  items,
  params,
  bookingTime,
  courts,
  workTime,
  waitingList,
  activeTimeList
}: Props): ColumnsType<TableData> {
  return (
    [TableTimePicker({ onTimeChange, onTimeClick, activeTimeList }), {
      dataIndex: 'columns',
      title: <TableSchedules currentTime={bookingTime} onTimeChange={onTimeChange} />,
      children: [
        ...GraphColumns({
          editWaiting,
          courts,
          params,
          handleCheckDetail,
          handleBooking,
          items,
          workTime,
          waitingList
        }),
        {
          onCell: () => ({
            style: {
              border: 'none',
              backgroundColor: 'white'
            }
          })
        }
      ]
    }]
  );
}

export default BookingTableColumns;
